<template>
	<div>
		<div ref="modalPdfViewer" 
			class="modal fade" :class="{ show: active, 'd-block': active }"
			tabindex="-1" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" 
				role="document">
				<div class="modal-content">
					<div class="modal-header">
						<!-- <h5 class="modal-title">
							{{ $t('default.modal.pdf.viewer.title') }}
						</h5> -->
						<div align="center" class="d-flex justify-content">
							<b-button class="btn btn-success btn-sm" 
							@click="printPdf">
								<fa icon="print"/>
								{{this.$t('dataTable.print')}}
							</b-button>
							&ensp;
							<b-button class="btn btn-success btn-sm" 
								@click="downloadPdf">
								<fa icon="save"/>
								{{this.$t('dataTable.download')}}
							</b-button>
						</div>
						<button
							type="button"
							class="close btn-lg"
							data-dismiss="modal"
							aria-label="Close"
							@click="modalToggle">
							<span aria-hidden="true" style="color:red;">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<b-container>
							<!-- PDF VIEWER  style="height: 100vh; width: 100vw"-->
							<pdf-vue ref="pdfRef" :src="src" />
						</b-container>
					</div>
					<div class="modal-footer">
						<b-button class="btn btn-success btn-sm" 
							@click="printPdf">
								<fa icon="print"/>
								{{this.$t('dataTable.print')}}
							</b-button>
							<b-button class="btn btn-success btn-sm" 
								@click="downloadPdf">
								<fa icon="save"/>
								{{this.$t('dataTable.download')}}
							</b-button>
						<b-button class="btn btn-dark btn-sm" 
							@click="modalToggle">
							<fa icon="times"/>
							{{ $t("default.button.close") }}
						</b-button>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import PDF from "pdf-vue3";
	export default {
		name: "modal-pdf-viewer",
		components: {
			'pdf-vue':PDF
		},
		props: ['pdfSrc', 'pdfName'],
		data() {
			return {
				active: false	,
				src: this.pdfSrc,
				// fileName: this.pdfName
			}
		},
		updated() {
			this.src = this.pdfSrc;
			// this.fileName = this.pdfName;
		},
		methods:{
			downloadPdf() {
				this.$refs.pdfRef.download(this.pdfName);
			},
			printPdf() {
				this.$refs.pdfRef.print();
			},
			async modalToggle() {
				if(this.active)
					this.active = false
				else
					this.active = true
			}

		}

	}
</script>